"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_big_calendar_1 = require("react-big-calendar");
require("react-big-calendar/lib/css/react-big-calendar.css");
var react_bootstrap_1 = require("react-bootstrap");
var react_router_1 = require("react-router");
var styled_components_1 = __importDefault(require("styled-components"));
var App_1 = require("../../App");
// Create a styled component for the calendar container
var CalendarContainer = (0, styled_components_1.default)(react_bootstrap_1.Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 20px;\n"], ["\n  padding: 20px;\n"])));
// Define the localizer to use for the calendar
var localizer = (0, react_big_calendar_1.momentLocalizer)(moment_1.default);
// Define the views to use for the calendar
var views = {
    month: true,
    week: true,
};
// Define the calendar component
var CalendarComponent = function (_a) {
    var Events = _a.Events, path = _a.path, onSelect = _a.onSelect, onNew = _a.onNew;
    var _b = (0, App_1.useEloise)(), theme = _b.theme, logic = _b.logic;
    var navigate = (0, react_router_1.useNavigate)();
    logic.hooks.useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        var ats;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (Events) {
                        setEvents(Events);
                    }
                    if (!path) return [3 /*break*/, 2];
                    return [4 /*yield*/, logic.fb.docs.getUserCollection(path)];
                case 1:
                    ats = _a.sent();
                    if (ats) {
                        setEvents(ats.map(function (x) {
                            return {
                                data: {
                                    title: x.data.title,
                                    start: x.data.date,
                                    type: x.data.type,
                                    end: x.data.date,
                                },
                                id: x.id,
                            };
                        }));
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); });
    // Define state for the events data
    var _c = (0, react_1.useState)(), events = _c[0], setEvents = _c[1];
    // Define function to handle adding new events
    var handleNew = function (slotInfo) {
        onNew(slotInfo);
    };
    // Define function to style the events
    var eventStyleGetter = function (event) {
        return {
            style: {
                backgroundColor: theme.colors[0],
                borderRadius: "5px",
                opacity: 0.8,
                color: "white",
                border: "0px",
                display: "block",
            },
        };
    };
    var handleSelectEvent = function (event) {
        onSelect && onSelect(event);
    };
    return (react_1.default.createElement(CalendarContainer, null,
        react_1.default.createElement(react_big_calendar_1.Calendar, { localizer: localizer, events: events, views: views, selectable: true, onSelectSlot: handleNew, defaultView: react_big_calendar_1.Views.WEEK, style: { height: "100vh" }, eventPropGetter: eventStyleGetter, onSelectEvent: handleSelectEvent })));
};
exports.default = CalendarComponent;
var templateObject_1;
